import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import DashboardLayout from "../../layouts/DashboardLayout";
import api from "../../api";

// Platform admin: the questionnaires every clinic gets, their sources and
// licences. Their translations are in the next menu items.
export default function AdminQuestionnaires() {
  const [list, setList] = useState([]);
  const load = () => api.getAdminMeasures().then((r) => setList(r.data || [])).catch(() => setList([]));
  useEffect(() => { load(); }, []);

  const setLicence = async (m, enabled) => {
    try {
      await api.setMeasureLicence(m.licence_gate, enabled);
      toast.success(enabled ? `${m.short_name} switched on for every clinic` : `${m.short_name} hidden from clinics`);
      load();
    } catch (e) { toast.error(e?.response?.data?.error || "Couldn't save."); }
  };

  return (
    <DashboardLayout>
      <div className="max-w-5xl mx-auto space-y-4">
        <h1 className="text-2xl font-bold text-secondary-900">Questionnaires &amp; licences</h1>
        <div className="rounded-lg border border-gray-200 bg-white overflow-x-auto">
          <table className="w-full text-sm min-w-[640px]">
            <thead className="bg-gray-50 text-xs uppercase tracking-wide text-gray-500">
              <tr><th className="text-left px-4 py-2.5">Questionnaire</th><th className="text-left px-4 py-2.5">Asked by</th><th className="text-left px-4 py-2.5">Languages</th><th className="text-left px-4 py-2.5">Licence</th></tr>
            </thead>
            <tbody>
              {list.map((m) => (
                <tr key={m.code} className="border-t border-gray-100 align-top">
                  <td className="px-4 py-3"><p className="font-semibold text-gray-800">{m.name}</p><p className="text-xs text-gray-500">{m.source}</p></td>
                  <td className="px-4 py-3 text-gray-700">{m.administered_by === "patient" ? "Patient (app or session)" : "Clinician (in session)"}</td>
                  <td className="px-4 py-3 text-gray-700">{(m.languages || []).map((l) => l.code).join(", ")}</td>
                  <td className="px-4 py-3">
                    {m.licence_gate ? (
                      <div className="space-y-1">
                        <label className="normal-case font-sans tracking-normal inline-flex items-center gap-2 text-sm">
                          <input type="checkbox" checked={!!m.licence_enabled} onChange={(e) => setLicence(m, e.target.checked)} />
                          {m.licence_enabled ? "On for clinics" : "Hidden - awaiting permission"}
                        </label>
                        <p className="text-xs text-amber-700">{m.licence_note}</p>
                      </div>
                    ) : <span className="text-xs text-emerald-700">Free to use</span>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
